var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',_vm._b({attrs:{"options":_vm.entitiesOptions,"clear-value":"","clearable":"","filter":""},model:{value:(_vm.entity),callback:function ($$v) {_vm.entity=$$v},expression:"entity"}},'q-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }